import React, {useEffect, useState} from "react"
import {useParams} from "react-router-dom"

import {Form} from "./Form"
import {getLayout} from "./Layouts"

import {api} from "@indebted/api"
import {ErrorPage} from "@indebted/components/Error"
import {LoadingPage} from "@indebted/components/Loading"

function Duplicate() {
	const {id} = useParams()
	const [component, setComponent] = useState(<LoadingPage />)

	useEffect(() => {
		api.emailTemplate
			.get(id)
			.then((template) => {
				const layout = getLayout(template.LayoutID)

				const initialState = {
					PreviewOptions: [],
					FromName: template.FromName,
					Subject: template.Subject,
					LayoutID: template.LayoutID,
					LayoutAttributes: template.LayoutAttributes,
					Locale: template.Locale,
					ForValidationPeriod: template.ForValidationPeriod,
					ForPreChargeOff: template.ForPreChargeOff,
					Archived: template.Archived,
					ID: template.ID,
					Tags: template.Tags,
				}

				setComponent(
					<Form
						title="Duplicate Email Template"
						initialState={initialState}
						LayoutComponent={layout.component}
						disabled={false}
					/>,
				)
			})
			.catch((error) => {
				setComponent(<ErrorPage message={error.Message} />)
			})
	}, [id])

	return component
}

export {Duplicate}
